import { useState } from "react";
import { Sparkles, KeyRound } from "lucide-react";

interface LoginProps {
  onSubmit: (key: string) => void;
}

export function Login({ onSubmit }: LoginProps) {
  const [key, setKey] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!key.trim()) {
      setError("Введите API key");
      return;
    }
    // Сохраним ключ — App сама перезайдёт когда authed=true
    onSubmit(key.trim());
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="card w-full max-w-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <Sparkles className="text-astro-gold" size={28} />
          <div>
            <h1 className="font-display text-2xl font-bold">AstroV2 Admin</h1>
            <p className="text-sm text-white/50">Гороскоп-генерация и постинг</p>
          </div>
        </div>

        <label className="block">
          <span className="text-sm text-white/60">API key</span>
          <div className="mt-1 relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" size={18} />
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="64-символьный hex"
              autoFocus
              spellCheck={false}
              className="w-full bg-black/30 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-sm font-mono focus:outline-none focus:border-astro-violet/50"
            />
          </div>
        </label>

        {error && <div className="mt-3 text-rose-400 text-sm">{error}</div>}

        <button type="submit" className="mt-6 w-full btn-primary">
          Войти
        </button>

        <p className="mt-4 text-xs text-white/40 text-center">
          Ключ хранится локально в браузере. Не передавайте его сторонним лицам.
        </p>
      </form>
    </div>
  );
}
